import React, { useEffect, useMemo, useRef } from 'react'
import * as classes from './Footer.module.scss'
import cn from 'classnames'
import Container from '../Container/Container'
import { Link } from 'gatsby'
import Col from './Col'
import Social from '../Social/Social'
import { deleteHtmlTag } from '../../../utils/deleteHtmlTag'
import { getHrefToHome } from '../../../utils/getHrefToHome'
import { gsap } from 'gsap/dist/gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import IconPartner from './../../icons/IconPartner'
import LogoLayout from '../../../images/footer/LogoLayout'
import FooterLogo from '../../icons/footerLogo'

gsap.registerPlugin(ScrollTrigger)

function Footer({ footer, projects, data, lang }) {
    const linksCompany = useMemo(() => footer.filter((item) => item?.parentSection?.id.includes(114159109) && item.url), [])
    const linksNews = useMemo(() => footer.filter((item) => item?.parentSection?.id.includes(114159272) && item.url), [])
    const linksInvestors = useMemo(
        () =>
            footer.filter(
                (item) => (item?.id.includes(143625003) && item.url) || (item?.id.includes('GZ4zA102ShibYZHKYXXMyg') && item.url)
            ),
        []
    )
    const linksContacts = useMemo(() => footer.filter((item) => item?.parentSection?.id.includes(114159305) && item.url), [])

    const policyLink = useMemo(() => deleteHtmlTag(data.policy.value, 'p'), [])
    const copy = useMemo(() => deleteHtmlTag(data.copy.value, 'p'), [])
    const developer = useMemo(() => deleteHtmlTag(data.developer.value, 'p'), [])

    const fb = data.fb.url
    const linkedin = data.linkedin.url
    const inst = data.inst.url
    const YouTube = data.YouTube.url

    const hrefHome = getHrefToHome(lang)
    const lineTopRef = useRef(null)

    const linksProjects = useMemo(
        () =>
            projects.map((item) => {
                return { title: item.title, url: `${lang === 'en' ? '/en' : ''}/projects/${item.urlCode}/` }
            }),
        []
    )

    const company = {
        title: footer.find((item) => item.id.includes(114159109))?.title,
        items: [...linksCompany, ...linksNews]
    }

    const investors = {
        title: footer.find((item) => item.id.includes('W_2ooGZeTlmKz6gWQiAhCA'))?.title,
        items: linksInvestors
    }

    const projectsContent = {
        title: footer.find((item) => item.id.includes(114159238))?.title,
        items: linksProjects
    }

    const contacts = {
        title: footer.find((item) => item.id.includes(114159305))?.title,
        items: linksContacts
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            gsap.to(lineTopRef.current, {
                duration: 1.4,
                width: '100%',
                ease: 'cubicBezier(0.25, 0.1, 0.25, 1)',
                scrollTrigger: {
                    trigger: lineTopRef.current,
                    start: 'top 95%'
                }
            })
        }, 1500)

        return () => clearTimeout(timer)
    }, [])

    return (
        <footer className={cn(classes.Footer, 'js-block-dark')}>
            <div>
                <LogoLayout className={classes.LogoLayout} />
            </div>
            <Container>
                <div className={cn(classes.Top, { [classes.LangHY]: lang === 'hy' })}>
                    <div className={classes.LogoWrap}>
                        <Link to={hrefHome}>
                            <FooterLogo isLight={true} />
                        </Link>

                        <IconPartner />
                    </div>

                    <Col data={company} className={classes.ColCompany} lang={lang} first></Col>

                    <Col data={investors} lang={lang} />

                    <Col data={projectsContent} className={classes.ColProjects} lang={lang}></Col>

                    <Col data={contacts} className={classes.ColContacts} lang={lang}>
                        <Social
                            fb={{
                                url: fb
                            }}
                            linkedin={{
                                url: linkedin
                            }}
                            inst={{
                                url: inst
                            }}
                            youTube={{
                                url: YouTube
                            }}
                        />
                    </Col>
                </div>
                <div className={classes.FooterLegal}>
                    <p className={classes.Copyright} dangerouslySetInnerHTML={{ __html: copy }} />
                    <p className={classes.Policy} dangerouslySetInnerHTML={{ __html: policyLink }} />
                    <p className={classes.Author} dangerouslySetInnerHTML={{ __html: developer }} />
                </div>
            </Container>
        </footer>
    )
}

export default Footer
